<template>
    <svg width="21" height="13" viewBox="0 0 21 13">
        <path :fill="color" d="M0,0v13h21V0H0z M10.5,8.8L1.8,1h17.4L10.5,8.8z M6.1,6.2L1,11.3V1.7L6.1,6.2z M6.8,6.9l3.7,3.3l3.7-3.3
	l5.1,5.1H1.7L6.8,6.9z M14.9,6.2L20,1.6v9.7L14.9,6.2z"/>
    </svg>
</template>
<script>
export default {
    props: {
        color: {
            type: String,
            default: '#636772'
        }
    }
}
</script>